document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-sh-help2]').forEach(function (root) {
    var trail = [];
    var replaying = false;

    function syncBackVisibility(backBtn) {
      if (!backBtn) return;
      backBtn.hidden = trail.length === 0;
    }

    root.addEventListener('click', function (e) {
      var choice = e.target.closest('[data-sh-next][data-sh-key]');
      if (choice && !replaying) {
        trail.push({ key: choice.dataset.shKey, value: choice.dataset.shValue });
        setTimeout(function () { syncBackVisibility(root.querySelector('[data-sh-back]')); }, 0);
      }
    }, true);

    var oldBack = root.querySelector('[data-sh-back]');
    if (oldBack) {
      var newBack = oldBack.cloneNode(true);
      oldBack.replaceWith(newBack);
      syncBackVisibility(newBack);

      newBack.addEventListener('click', function () {
        if (!trail.length || replaying) return;

        trail.pop();
        var keep = trail.slice();
        trail = [];
        replaying = true;

        var reset = root.querySelector('[data-sh-reset]');
        if (reset) reset.click();

        setTimeout(function replay(i) {
          if (i >= keep.length) {
            trail = keep.slice();
            replaying = false;
            syncBackVisibility(newBack);
            return;
          }

          var step = keep[i];
          var match = Array.from(root.querySelectorAll('[data-sh-next][data-sh-key]')).find(function (b) {
            return b.dataset.shKey === step.key && b.dataset.shValue === step.value;
          });

          if (!match) {
            trail = keep.slice(0, i);
            replaying = false;
            syncBackVisibility(newBack);
            return;
          }

          match.click();
          setTimeout(function () { replay(i + 1); }, 0);
        }, 0);
      });
    }

    var resetButton = root.querySelector('[data-sh-reset]');
    if (resetButton) {
      resetButton.addEventListener('click', function () {
        if (replaying) return;
        trail = [];
        setTimeout(function () { syncBackVisibility(root.querySelector('[data-sh-back]')); }, 0);
      });
    }

    var oldQuick = root.querySelector('[data-sh-faststart]');
    if (oldQuick) {
      var quick = oldQuick.cloneNode(true);
      quick.removeAttribute('data-sh-faststart');
      quick.setAttribute('data-sh-safe-faststart', '');
      oldQuick.replaceWith(quick);

      quick.addEventListener('click', function () {
        var reset = root.querySelector('[data-sh-reset]');
        if (reset) reset.click();
        trail = [];
        syncBackVisibility(root.querySelector('[data-sh-back]'));

        var stage = root.querySelector('[data-sh-stage]');
        if (!stage) return;

        stage.innerHTML = '<div class="sh-help2__question"><h2>Before we sort out what changed: are there emergency red flags right now?</h2><p>Choose yes if you see severe breathing trouble, collapse, uncontrolled bleeding, repeated seizures, major trauma, suspected poisoning, heatstroke, inability to urinate, a swollen abdomen with repeated dry heaving, or severe distress.</p><details class="sh-help2__why"><summary>Why we’re asking this</summary><p>Quick Start should never bypass the emergency safety screen.</p></details><div class="sh-help2__choices"><button type="button" class="sh-help2__choice" data-sh-quick-emergency="yes">Yes — one or more red flags</button><button type="button" class="sh-help2__choice" data-sh-quick-emergency="no">No</button><button type="button" class="sh-help2__choice" data-sh-quick-emergency="unsure">I’m not sure</button></div></div>';
      });
    }

    root.addEventListener('click', function (e) {
      var q = e.target.closest('[data-sh-quick-emergency]');
      if (!q) return;

      var mode = q.dataset.shQuickEmergency;
      if (mode === 'yes' || mode === 'unsure') {
        var emergency = root.querySelector('[data-sh-emergency]');
        if (emergency) emergency.click();
        return;
      }

      var reset = root.querySelector('[data-sh-reset]');
      if (reset) reset.click();
      trail = [];
      syncBackVisibility(root.querySelector('[data-sh-back]'));

      var unsureLife = Array.from(root.querySelectorAll('[data-sh-next][data-sh-key="life"]')).find(function (b) {
        return b.dataset.shValue === 'not sure';
      });
      if (unsureLife) unsureLife.click();

      setTimeout(function () {
        var a = Array.from(root.querySelectorAll('[data-sh-next][data-sh-key="adoption"]')).find(function (b) {
          return b.dataset.shValue === 'recent transition possible';
        });
        if (a) a.click();

        setTimeout(function () {
          var v = Array.from(root.querySelectorAll('[data-sh-next][data-sh-key="vulnerability"]')).find(function (b) {
            return b.dataset.shValue === 'unknown';
          });
          if (v) v.click();

          setTimeout(function () {
            var n = Array.from(root.querySelectorAll('[data-sh-next][data-sh-key="redflags"]')).find(function (b) {
              return b.dataset.shValue === 'no';
            });
            if (n) n.click();

            setTimeout(function () {
              var c = Array.from(root.querySelectorAll('[data-sh-next][data-sh-key="concern"]')).find(function (b) {
                return b.dataset.shValue === 'something changed';
              });
              if (c) c.click();
              trail = [
                { key: 'life', value: 'not sure' },
                { key: 'adoption', value: 'recent transition possible' },
                { key: 'vulnerability', value: 'unknown' },
                { key: 'redflags', value: 'no' },
                { key: 'concern', value: 'something changed' }
              ];
              syncBackVisibility(root.querySelector('[data-sh-back]'));
            }, 0);
          }, 0);
        }, 0);
      }, 0);
    });
  });
});